import { Model } from "./Helpers";
import { IFlight } from "@vmosolutions/oc-interfaces";

export interface IAlertButtonOptions {
  label: string;
  disabled?: boolean;
  handler?: (parm1?: any, parm2?: any) => void;
}

export interface IAlert {
  title?: string;
  message?: string;
  buttons?: IAlertButtonOptions[];
  textFieldLabel?: string;
  textField?: string;
  formvalue?: any[];
  formvaluekey?: string;
  placeholder?: string;
  date?: string;
  selectedFlights?: IFlight[];

  handleClose?: () => void;
  handleSubmit?: (parm1?: any, parm2?: any) => void;
  handleChange?: (parm1?: any) => void;
}

export const AlertModel = Model<IAlert>({
  title: undefined,
  message: undefined,
  buttons: undefined,
  textFieldLabel: undefined,
  textField: undefined,
  formvalue: undefined,
  formvaluekey: undefined,
  placeholder: undefined,
  date: undefined,
  selectedFlights: undefined,
  handleClose: undefined,
  handleSubmit: undefined,
  handleChange: undefined,
});

export class Alert extends AlertModel {
  public title?: string;
  public message?: string;
  public buttons?: IAlertButtonOptions[];
  public textFieldLabel?: string;
  public textField?: string;
  public formvalue?: any[];
  public formvaluekey?: string;
  public placeholder?: string;
  public date?: string;
  public selectedFlights?: IFlight[];
  handleClose?: () => void;
  handleSubmit?: (parm1?: any, parm2?: any) => void;
  handleChange?: (parm1?: any) => void;
}
